// MSDS 검색 필드 아래 정렬 라디오(이름순/날짜순) → 자식 autocomplete 컴포넌트의
// data-autocomplete-extra-params-value 를 갱신.
// 사용:
//   <div data-controller="msds-search-sort">
//     <%= render 'components/basics/autocomplete', ... %>
//     <fieldset>
//       <input type="radio" name="..." value="name" checked
//              data-action="change->msds-search-sort#update">
//       <input type="radio" name="..." value="date"
//              data-action="change->msds-search-sort#update">
//     </fieldset>
//   </div>
//
// autocomplete controller 는 값 변경을 감지해 현재 검색어로 즉시 재검색.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  update(event) {
    const autocompleteEl = this.element.querySelector('[data-controller~="autocomplete"]')
    if (!autocompleteEl) return
    const current = JSON.parse(autocompleteEl.dataset.autocompleteExtraParamsValue || '{}')
    current.sort = event.target.value
    autocompleteEl.dataset.autocompleteExtraParamsValue = JSON.stringify(current)
  }
}
